import { render, staticRenderFns } from "./PhoneButton.vue?vue&type=template&id=85eae57a&scoped=true&"
import script from "./PhoneButton.vue?vue&type=script&lang=js&"
export * from "./PhoneButton.vue?vue&type=script&lang=js&"
import style0 from "./PhoneButton.vue?vue&type=style&index=0&id=85eae57a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eae57a",
  null
  
)

export default component.exports